import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdminSettingsService {
  baseUrl: any;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.baseUrl;
  }

  adminSettingsCreate(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-hourly-rate-markers', payload);
  }

  adminSettingsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/get-hourly-rate-markers', payload);
  }

  setJobId(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-jobid-settings', payload);
  }

  jobIdSettings(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/get-jobid-settings', payload);
  }

  setTLSSettings(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-tls-settings', payload);
  }

  getTLSSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-tls-settings');
  }
  getClientTLSSettings(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/client-tls-settings', payload);
  }
  addMachineError(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/add-error', payload);
  }

  getMachineError(payload: any): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/error-list', payload);
  }

  deleteMachineError(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/delete-error', payload);
  }

  blockErrorMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/block-error', payload);
  }

  unblockErrorMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/unblock-error', payload);
  }

  updateErrorStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/update-error-status', payload);
  }

  addJobColour(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-job-color-settings', payload);
  }

  getJobColor(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-job-color-settings');
  }

  bulkDeleteBlockUnblock(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/bulk-update-error', payload);
  }

  testEmailSettings(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/test101', payload);
  }

  //Proposal email
  saveProposalEmail(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/save-proposal-settings', payload);
  }

  getProposalSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-proposal-settings');
  }

  changeJobStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-job-status-settings', payload);
  }

  adminRegistration(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-admin-settings', payload);
  }

  engineerRegistration(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-engineer-settings', payload);
  }

  clientRegistration(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-client-settings', payload);
  }

  getAdminSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-admin-settings');
  }

  getClientSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-client-settings');
  }

  getEngineerSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-engineer-settings');
  }

  getJobStatusSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-job-status-settings');
  }

  changeQuoteStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-quote-status-settings', payload);
  }

  getQuoteStatusSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-quote-status-settings');
  }

  setQuoteId(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-quoteid-settings', payload);
  }

  getQuoteId(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/get-quoteid-settings', payload);
  }

  //Industry
  categoryList(
    filters: Object = { deletedAt: null, active: 1 },
    orderBy: Record<string, 1 | -1> = { name: 1 }
  ): Observable<any> {
    let params = { filters, orderBy };
    return this.http.post(this.baseUrl + 'jobs/category/category-list', params);
  }

  groupCategories(
    filters: Object = { deletedAt: null, createdAt: -1 },
    orderBy: Record<string, 1 | -1> = { name: 1 }
  ): Observable<any> {
    let params = { filters, orderBy };
    return this.http.post(this.baseUrl + 'jobs/category/group-categories', params);
  }

  createCategory(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/category/create', payload);
  }

  updateCategory(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/category/update/${id}`, payload);
  }

  deleteCategory(id: string, payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/category/delete/${id}`, payload);
  }

  saveCategoryFields(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'jobs/createbulk-jobfields', payload);
  }

  getCategoryWithFields(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `jobs/list-jobfields`, payload);
  }

  callEventList(
    filters: Object = { deletedAt: null, active: 1 },
    orderBy: Record<string, 1 | -1> = { name: 1 }
  ): Observable<any> {
    let params = { filters, orderBy };
    return this.http.post(this.baseUrl + 'callLog/call-events/list', params);
  }

  createCallEvent(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'callLog/call-events/create', payload);
  }

  updateCallEvent(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `callLog/call-events/${id}/update`, payload);
  }

  deleteCallEvent(id: string, payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + `callLog/call-events/${id}/delete`, payload);
  }

  // Manage Tag
  tagList(): Observable<any> {
    return this.http.get(this.baseUrl + 'deal/get-tag-proposal');
  }

  createTag(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'deal/add-tag-proposal', payload);
  }

  updateTag(payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `deal/update-tag-proposal`, payload);
  }

  deleteTag(payload: any): Observable<any> {
    return this.http.patch(this.baseUrl + `deal/soft-delete-tag-proposal`, payload);
  }

  // Manage Lead Source
  sourceList(): Observable<any> {
    return this.http.get(this.baseUrl + 'leadSource/get-all-lead-source');
  }

  createSource(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leadSource/add-lead-source', payload);
  }

  // updateSource(id: number | string, payload: any): Observable<any> {
  //   return this.http.put(`${this.baseUrl}leadSource/update-lead-source/${id}`, payload);
  // }

  updateSource(payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}leadSource/update-lead-source/${payload._id}`, payload);
  }

  // deleteSource(payload: any): Observable<any> {
  //   return this.http.delete(`${this.baseUrl}leadSource/delete-lead-source/${payload._id}`, payload);
  // }

  deleteSource(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}leadSource/delete-lead-source/${id}`);
  }

  resetApi(id: any): Observable<any> {
    return this.http.post(this.baseUrl + `leadSource/${id}/reset-api-key`, {});
  }

  // GET lead-statuses
  leadStatusList(orderBy?: string, order?: 1 | -1): Observable<any> {
    let qParams: Record<string, any> = {};
    if (orderBy) {
      qParams['orderBy'] = orderBy;
    }
    if (order) {
      qParams['order'] = order.toString();
    }
    return this.http.get(this.baseUrl + 'settings/lead-statuses', {
      params: qParams,
    });
  }
  // POST lead-statuses
  createOrUpdateLeadStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/lead-statuses', payload);
  }
  // DELETE lead-statuses/:id
  deleteLeadStatus(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}settings/lead-statuses/${id}`);
  }

  createOrUpdateDealStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/deal-statuses', payload);
  }
  // DELETE deal-statuses/:id
  deleteDealStatus(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}settings/deal-statuses/${id}`);
  }

  // GET deal-statuses
  dealStatusList(orderBy?: string, order?: 1 | -1): Observable<any> {
    let qParams: Record<string, any> = {};
    if (orderBy) {
      qParams['orderBy'] = orderBy;
    }
    if (order) {
      qParams['order'] = order.toString();
    }
    return this.http.get(this.baseUrl + 'settings/deal-statuses', {
      params: qParams,
    });
  }

  // Job Status methods
  createJobStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'job-status/create-job-status', payload);
  }

  jobStatusList(): Observable<any> {
    return this.http.get(this.baseUrl + 'job-status/list-job-statuses');
  }

  getJobStatus(id: string): Observable<any> {
    return this.http.get(this.baseUrl + `job-status/getJobStatus/${id}`);
  }

  updateJobStatus(id: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `job-status/update-job-status/${id}`, payload);
  }

  deleteJobStatus(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + `job-status/delete-job-status/${id}`);
  }

  // Service CMS methods
  createServiceCMS(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'storefront/create-service-cms', payload);
  }

  updateServiceCMS(id: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `storefront/update-service-cms/${id}`, payload);
  }

  listServiceCMS(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'storefront/service-cms-list', payload);
  }

  deleteServiceCMS(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + `storefront/delete-service-cms/${id}`);
  }

  // Storefront Pages methods
  createStorefrontPage(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'storefront/create-storefront-pages', payload);
  }

  updateStorefrontPage(id: string, payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `storefront/update-storefront-pages/${id}`, payload);
  }

  listStorefrontPages(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'storefront/pages/list', payload);
  }

  deleteStorefrontPage(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + `storefront/delete-pages/${id}`);
  }

  getStorefrontPageBySlug(slug: string): Observable<any> {
    return this.http.get(this.baseUrl + `storefront/pages/${slug}`);
  }

  getStorefrontPageById(id: string): Observable<any> {
    return this.http.get(this.baseUrl + `storefront/pages/${id}`);
  }

  // Contact methods
  getContactList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'storefront/all-contactdata', payload);
  }

  getContactById(id: string): Observable<any> {
    return this.http.get(this.baseUrl + `storefront/contactby-id/${id}`);
  }

  updateContactStatus(id: string, payload: any): Observable<any> {
    return this.http.patch(this.baseUrl + `storefront/update-contactstatus/${id}`, payload);
  }

  deleteContact(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + `storefront/contact-soft-delete/${id}`);
  }
}
